module.exports = __webpack_public_path__ + "img/10_Faltschieben-Slido VF@2x.0a1c0a1e.jpg";